import { useState } from 'react'
import * as actions from '@actions'
import * as store from '@store'
import CustomModal, { ModalBody, ModalFooter, ModalHeader } from '@/components/shared/CustomModal'
import { useWireValue } from '@forminator/react-wire'
import { toast } from 'react-toastify'

const RunsheetAddToTabModal = ({ runsheetId, modalState, markedDocuments, setMarkedDocuments }) => {
    
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = modalState
    const tabs = useWireValue(store.runsheetTabs)
    const [selectedTabs, setSelectedTabs] = useState([])
    
    const handleTabSelection = tabId => {
        setSelectedTabs(prev => 
            prev.includes(tabId) 
                ? prev.filter(id => id !== tabId)
                : [...prev, tabId],
        )
    }
    
    const handleClose = () => {
        setShowModal(false)
        setSelectedTabs([])
    }
    
    const handleAdd = async () => {
        setLoading(true)
        
        try {
            selectedTabs.forEach(async st => {
                await actions.addDocumentValuesToRunsheetTab(runsheetId, st , markedDocuments)
            })
            toast.success(`Successfully added the documents to "${tabs
                .filter(t => selectedTabs.includes(t.id))
                .map(t => t.name)}" tabs.`)
            handleClose()
        } catch (err) {
            toast.error('Failed to add documents to the selected tab.')
        }
        
        setLoading(false)
        setMarkedDocuments([])
    }
    
    return (
        <CustomModal open={showModal} modalHandler={handleClose}>
            
            <ModalHeader>
                Add documents to tab
                <div className="text-sm">
                    Selected documents will be linked to the new tab
                </div>
            </ModalHeader>
            
            <ModalBody>
                <p className="text-neutral">There {markedDocuments.length === 1 ? 'is' : 'are'}{' '}
                    {markedDocuments.length} selected {markedDocuments.length === 1 ? 'document' : 'documents'}.
                </p>
                <p className="mt-2">
                    <div className="flex flex-col gap-2 pb-2 bg-base-200 rounded">
                        <label className="p-2 border-b border-base-100">Select a tab</label>
                        <div className="max-h-[400px] overflow-auto">
                            <ul className="menu flex flex-col gap-1 px-4">
                                {tabs
                                    .filter(t => t.id !== '0')
                                    .map(tab =>
                                        <li key={tab.id}>
                                            <label className="label flex justify-start gap-2 cursor-pointer p-2">
                                                <input 
                                                    className="checkbox checkbox-sm" 
                                                    type="checkbox" 
                                                    checked={selectedTabs.includes(tab.id)} 
                                                    onChange={() => handleTabSelection(tab.id)}/>
                                                <span className="label-text flex-1">{tab.name}</span>
                                            </label>
                                        </li>,
                                    )}
                            </ul>
                        </div>
                    </div>
                </p>
            </ModalBody>
            
            <ModalFooter>
                <button
                    className="btn btn-primary btn-outline"
                    onClick={handleClose}>
                        Cancel
                </button>
                <button
                    disabled={loading || !selectedTabs.length}
                    className="btn btn-primary"
                    onClick={handleAdd}>
                        Add
                </button>
            </ModalFooter>
        
        </CustomModal>
    )
}

export default RunsheetAddToTabModal